// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1za3n","colMaxWidth":"Table_colMaxWidth__27Vhz"};